import API from './api';
import CachedApi from './cachedApi';
import {buildUrlFor} from './urls';
import {enqueueSnackbar} from "../redux/actions/snackbarActions"
import store from "../redux/store";
import {successMessage, errorMessage} from "./alertMessages";
import { getSnackbarLabels } from '../utils/languages';
import { getSelectorPerPage } from './pagination';

const getPage = (api, url, params) => (
  api.get(url, { params })
    .then((response) => ({ data: JSON.parse(JSON.stringify(response.data)) }))
    .catch((error) => ({ error }))
);

export const ItemsService = {
    get: function (model, paginationParams = {}, api = CachedApi) {
      const url = buildUrlFor(model)
      const params = {
        ...(paginationParams.selector ? { per_page: getSelectorPerPage() } : {}),
        ...paginationParams,
      };

      return getPage(api, url, params)
        .then((result) => {
          if (result.error) {
            store.dispatch(enqueueSnackbar(errorMessage(getSnackbarLabels.error[model].get)))
          }
          return result;
        });
    },
    getById: function (model,id) {
      const url = buildUrlFor(model)
      return API.get(url + id, id)
        .then(function (response) {
          return {data: response.data};
        })
        .catch(function (error) {
          store.dispatch(enqueueSnackbar({ open: true, variant: 'error', message: 'Se produjo un error'}))
          return {error};
        })
    },
    post: function(model, params){
      const url = buildUrlFor(model)
      return API.post(url, params)
          .then((response) => {
            store.dispatch(enqueueSnackbar(successMessage(getSnackbarLabels.success[model].post)))
            return response
          })
          .catch((error) => {
            store.dispatch(enqueueSnackbar(errorMessage(getSnackbarLabels.error[model].post)))
            return error
          })
    },
    update: function(model, params){
      const url = buildUrlFor(model)
      return API.patch(url + params.id, params)
          .then((response) => {
            store.dispatch(enqueueSnackbar(successMessage(getSnackbarLabels.success[model].update)))
            return response
          })
          .catch((error) => {
            store.dispatch(enqueueSnackbar(errorMessage(getSnackbarLabels.error[model].update)))
            return error
          })
    },
    destroy: function(model, params){
      const url = buildUrlFor(model)
      return API.delete(url + params.id)
        .then(function (response) {
          store.dispatch(enqueueSnackbar(successMessage(getSnackbarLabels.success[model].delete)))
          return {data: response.data};
        })
        .catch(function (error) {
          const response = error.response.data[0];
          const includesDetails = Array.isArray(response);
          const data = includesDetails ? response[0] : response;
          const message = getSnackbarLabels.error[model][data]
            ?? getSnackbarLabels.error[model].delete;
          const details = includesDetails ? `: ${response[1]}` : '';
          
          store.dispatch(enqueueSnackbar(errorMessage(message, details)))
          return {error};
        })

    }
}
